/**
 * A local `YYYY-MM-DD`, built from the calendar fields rather than from
 * `toISOString()`.
 *
 * The legacy's `dateToDatabase` takes the ISO route and hands the API a UTC
 * day, so in Chile anything picked after 21:00 lands on tomorrow's date. It is
 * the same bug in both fronts, and this is the one place that avoids it.
 *
 * @param {Date} date
 * @returns {string}
 */
export const toLocalDateString = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * Today, on both ends.
 *
 * @returns {{ start_date: string, end_date: string }}
 */
export const getTodayRange = () => {
  const today = toLocalDateString(new Date());
  return { start_date: today, end_date: today };
};

/**
 * The last `days` days, ending today.
 *
 * @param {number} days
 * @returns {{ start_date: string, end_date: string }}
 */
export const getLastDaysRange = (days) => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);

  return { start_date: toLocalDateString(start), end_date: toLocalDateString(end) };
};
